import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { IconSizeClass } from '../../enums';

@Component({
  selector: 'educare-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  imports: [CommonModule, MatDialogActions, MatDialogContent, FormsModule]
})
export class ConfirmationDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);
  public readonly data = inject(MAT_DIALOG_DATA);
  private readonly cdr = inject(ChangeDetectorRef);

  iconSize: IconSizeClass = this.data.iconSize || IconSizeClass.Small;
  reason: string = '';

  constructor() {
    // Set allowHtml to false by default to prevent affecting other components
    this.data.allowHtml = this.data.allowHtml || false;
  }

  onSubmit(): void {
    if (this.data.submitWithoutClose === true) {
      this.data.onSubmitClick?.();
      return;
    }
    this.dialogRef.close({ action: true, reason: this.reason });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  /** Re-evaluates `isSubmitDisabled` when the opener updates state outside this view (e.g. screen lock + HTTP). */
  notifySubmitStateChange(): void {
    this.cdr.detectChanges();
  }
}
